import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";

export interface CausaSiniestro {
  id?: number;
  id_investigacion: number;
  id_siniestro: number;
  factor: "HUMANO" | "VEHICULO" | "VIA" | "ENTORNO";
  fase_haddon?: "PRE_SINIESTRO" | "SINIESTRO" | "POST_SINIESTRO";
  tipo_causa?: "BASICA" | "INMEDIATA" | "RAIZ";
  descripcion: string;
  estado?: number;
}

@Injectable({ providedIn: "root" })
export class CausasSiniestroService {
  private apiUrl = `${environment.apiUrl}/api/causas-siniestro`;

  constructor(private http: HttpClient) {}

  getByInvestigacionId(idInvestigacion: number | string): Observable<CausaSiniestro[]> {
    return this.http
      .get<CausaSiniestro[]>(`${this.apiUrl}/investigacion/${idInvestigacion}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getById(id: number | string): Observable<CausaSiniestro> {
    return this.http
      .get<CausaSiniestro>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  create(payload: CausaSiniestro[]): Observable<CausaSiniestro[]> {
    return this.http
      .post<CausaSiniestro[]>(this.apiUrl, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  update(id: number | string, payload: Partial<CausaSiniestro>): Observable<CausaSiniestro> {
    return this.http
      .put<CausaSiniestro>(`${this.apiUrl}/${id}`, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  delete(id: number | string): Observable<any> {
    return this.http
      .delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }
}